export enum ProjectTag {
    Animation = 'Animation',
    Commercials = 'Commercials',
    Foley = 'Foley',
    Jingles = 'Jingles',
    Mobile = 'Mobile',
    PodcastsVoice = 'PodcastsVoice',
}

export enum FilterItem {
    All = 'All',
    Animation = 'Animation',
    Commercials = 'Commercials',
    Foley = 'Foley',
    Jingles = 'Jingles',
    Mobile = 'Mobile',
    PodcastsVoice = 'Podcasts & Voice',
}